import log from "loglevel";

interface LoggerConfig {
	name: LoggerName;
	level: log.LogLevelDesc;
}

export enum LoggerName {
	BASE_CARD_VIEW = "baseCardView",
	AI_CARD_BLOCK_NOTE_VIEW = "aiCardBlockNoteView",
	AI_CARD_SHAPE_TOOL = "AICardShapeTool",
	AI_CARD_SHAPE_UTIL = "aiCardShapeUtil",
	AI_CARD_VIEW = "aiCardView",
	PREPRINT_CARD_BLOCK_NOTE_VIEW = "preprintCardBlockNoteView",
	PREPRINT_CARD_SHAPE_TOOL = "preprintCardShapeTool",
	PREPRINT_CARD_SHAPE_UTIL = "preprintCardShapeUtil",
	PREPRINT_CARD_VIEW = "preprintCardView",
	APP = "App",
	AUTH0_PROVIDER = "Auth0Provider",
	BOARD_EDITOR = "BoardEditor",
	BOARD_PERSISTENCE_CONTEXT = "BoardPersistenceContext",
	CARD_BLOCK_NOTE_VIEW = "cardBlockNoteView",
	CARD_CONTENT_EDITOR = "CardContentEditor",
	CARD_PERSISTENCE = "cardPersistence",
	NOTE_CARD_SHAPE_TOOL = "cardShapeTool",
	NOTE_CARD_SHAPE_UTIL = "cardShapeUtil",
	NOTE_CARD_VIEW = "noteCardView",
	CONTEXT_TOOLBAR = "contextToolbar",
	DEFAULT = "default",
	DRAFT = "Draft",
	DRAFT_BLOCK_NOTE_CONTAINER = "draftBlockNoteContainer",
	GENERATE_PREPRINT_CARD = "generateAnswerCard",
	GRAPHQL = "GraphQL",
	HOCUS_PROVIDER = "hocusProvider",
	ILLUMI_USER_PROVIDER = "IllumiUserProvider",
	NAV_BAR = "NavBar",
	TLDRAW_CUSTOM_UI_OVERRIDES = "tldrawCustomUiOverrides",
	WEBSOCKET_PROVIDER_STORE = "WebSocketProviderStore",
	Local_PROVIDER_STORE = "LocalProviderStore",
	FILE_CLIENT = "useFileClientLogger",
	S3_FILE_CLIENT = "useFileClientLogger",
	TLDRAW_CONTEXT = "tldrawContext",
	TLDRAW_YJS_STORE = "yjsTldDrawStore",
	TLDRAW_CONFIGURATOR = "TldrawConfigurator",
	YJS_CONTEXT = "YjsContext",
	YJS_CONTEXT_SUBDOCS = "YjsContextSubdocs",
	MIGRATIONS_NOTE_CARD = "Migrations_note_card",
	MIGRATIONS_AI_CARD = "Migrations_AI_card",
	MIGRATIONS_APPLY = "Migrations_Apply",
	TLDRAW_AUTOMATIONS = "tldrawAutomations",
	//defined in y-websocket library
	Y_WEBSOCKET_PROVIDER_GENERAL = "YWebsocketProviderLogger",
	Y_WEBSOCKET_AWARENESS = "YWebsocketProviderAwarenessLogger",
	Y_WEBSOCKET_SYNC = "YWebsocketProviderSyncLogger",
	YTL_STORE = "yTlDrawStore",
	CONNECTIVITY_LAMP = "ConnectivityLamp",
}

const loggerConfigs: LoggerConfig[] = [
	{ name: LoggerName.DEFAULT, level: log.levels.INFO },
	{ name: LoggerName.BASE_CARD_VIEW, level: log.levels.INFO },
	{ name: LoggerName.AI_CARD_BLOCK_NOTE_VIEW, level: log.levels.INFO },
	{ name: LoggerName.AI_CARD_SHAPE_TOOL, level: log.levels.INFO },
	{ name: LoggerName.AI_CARD_SHAPE_UTIL, level: log.levels.INFO },
	{ name: LoggerName.AI_CARD_VIEW, level: log.levels.INFO },
	{ name: LoggerName.APP, level: log.levels.INFO },
	{ name: LoggerName.AUTH0_PROVIDER, level: log.levels.INFO },
	{ name: LoggerName.BOARD_EDITOR, level: log.levels.INFO },
	{ name: LoggerName.BOARD_PERSISTENCE_CONTEXT, level: log.levels.INFO },
	{ name: LoggerName.CARD_BLOCK_NOTE_VIEW, level: log.levels.INFO },
	{ name: LoggerName.CARD_CONTENT_EDITOR, level: log.levels.INFO },
	{ name: LoggerName.CARD_PERSISTENCE, level: log.levels.INFO },
	{ name: LoggerName.NOTE_CARD_SHAPE_TOOL, level: log.levels.INFO },
	{ name: LoggerName.NOTE_CARD_SHAPE_UTIL, level: log.levels.INFO },
	{ name: LoggerName.NOTE_CARD_VIEW, level: log.levels.INFO },
	{ name: LoggerName.CONTEXT_TOOLBAR, level: log.levels.INFO },
	{ name: LoggerName.DRAFT, level: log.levels.INFO },
	{ name: LoggerName.DRAFT_BLOCK_NOTE_CONTAINER, level: log.levels.INFO },
	{ name: LoggerName.GENERATE_PREPRINT_CARD, level: log.levels.INFO },
	{ name: LoggerName.GRAPHQL, level: log.levels.INFO },
	{ name: LoggerName.HOCUS_PROVIDER, level: log.levels.INFO },
	{ name: LoggerName.ILLUMI_USER_PROVIDER, level: log.levels.INFO },
	{ name: LoggerName.NAV_BAR, level: log.levels.INFO },
	{ name: LoggerName.FILE_CLIENT, level: log.levels.INFO },
	{ name: LoggerName.S3_FILE_CLIENT, level: log.levels.INFO },
	{ name: LoggerName.TLDRAW_CUSTOM_UI_OVERRIDES, level: log.levels.INFO },
	{ name: LoggerName.WEBSOCKET_PROVIDER_STORE, level: log.levels.INFO },
	{ name: LoggerName.TLDRAW_CONTEXT, level: log.levels.INFO },
	{ name: LoggerName.TLDRAW_YJS_STORE, level: log.levels.INFO },
	{ name: LoggerName.TLDRAW_CONFIGURATOR, level: log.levels.INFO },
	{ name: LoggerName.MIGRATIONS_NOTE_CARD, level: log.levels.INFO },
	{ name: LoggerName.MIGRATIONS_AI_CARD, level: log.levels.INFO },
	{ name: LoggerName.MIGRATIONS_APPLY, level: log.levels.INFO },
	{ name: LoggerName.YJS_CONTEXT, level: log.levels.INFO },
	{ name: LoggerName.YJS_CONTEXT_SUBDOCS, level: log.levels.INFO },
	{ name: LoggerName.TLDRAW_AUTOMATIONS, level: log.levels.INFO },
	{ name: LoggerName.Y_WEBSOCKET_PROVIDER_GENERAL, level: log.levels.INFO },
	{ name: LoggerName.Y_WEBSOCKET_AWARENESS, level: log.levels.INFO },
	{ name: LoggerName.Y_WEBSOCKET_SYNC, level: log.levels.INFO },
	{ name: LoggerName.YTL_STORE, level: log.levels.INFO },
	{ name: LoggerName.CONNECTIVITY_LAMP, level: log.levels.INFO },
];

export function setupLoggers() {
	loggerConfigs.forEach(({ name, level }) => {
		if (name === LoggerName.DEFAULT) {
			log.setDefaultLevel(level);
		} else {
			log.getLogger(name).setLevel(level);
		}
	});
}

export function getLogger(name: string): log.Logger {
	return log.getLogger(name);
}
